import { render, staticRenderFns } from "./newsletters.vue?vue&type=template&id=bbc0ba92"
import script from "./newsletters.vue?vue&type=script&lang=ts"
export * from "./newsletters.vue?vue&type=script&lang=ts"
import style0 from "./newsletters.vue?vue&type=style&index=0&id=bbc0ba92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports